import { render } from "./Index.vue?vue&type=template&id=4bee806c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=4bee806c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4bee806c"

export default script